<pre [class.responsive]="responsive">
    <ng-content></ng-content>
</pre>
